<template>
  <div class="deblocking-container">
    <div class="replay-btn func-btn" @click="showTaskList">
      {{btnText}}
      <!-- <svg-icon icon-class="arrow" class-name="func-btn" v-if="multitask"></svg-icon> -->
    </div>
    <div class="task-mask func-btn" v-if="taskListStatus"></div>
    <div class="task-list func-btn" v-if="taskListStatus">
      <p class="task-list-desc func-btn">{{title}}</p>
      <ul class="task-list-content func-btn">
        <li class="task-list-item func-btn" v-for="item in taskList" :key="item.type">
          <span class="task-item-title func-btn">{{item.title}}</span>
          <span class="task-item-btn func-btn" @click="taskClick(item)">{{item.event}}</span>
        </li>
      </ul>
      <div @click="closeTaskList" class="close-task func-btn">
        <svg-icon icon-class="close" class-name="func-btn"></svg-icon>
      </div>
    </div>

    <div class="qrcode func-btn" v-if="qrcodeStatus">
      <p class="title func-btn">加群领限时免费直播名额</p>
      <img class="img func-btn" :src="groupQrcode">
      <p class="scan func-btn">微信扫码进群</p>
      <img class="close func-btn" src="../../assets/images/close.png" @click="toggleQrcode">
    </div>

    <ShareModel v-model="shareModelStatus" />
  </div>
</template>

<script>
  import ShareModel from '../ShareModel'
  import { getUnlockTask } from 'api/live'
  import { getToken } from '@/utils/utils'
  export default {
    name: "Deblocking",
    components: { ShareModel },
    props: {
      living: {
        type: Boolean,
        default: false
      },
      isReplay: {
        type: Boolean,
        default: false
      },
      handlewxLogin: {
        type: Function,
        require: true
      },
      groupQrcode: {
        type: String,
        default: ''
      },
      deblockId: [Number, String],
      pageTitle: String
    },
    data() {
      return {
        taskListStatus: false,
        qrcodeStatus: false,
        shareModelStatus: false,
        title: '',
        taskList: []
      }
    },
    computed: {
      btnText() {
        if (this.living) {
          return '解锁观看直播>'
        } else if (this.isReplay) {
          return '试听30秒，解锁观看视频 >'
        } else {
          // if (this.taskList.length === 1 ) {
          //   return this.taskList[0].description
          // } else {
          //   return '解锁精选直播>'
          // }
          return '解锁观看直播>'
        }
      },
      pageName() {
        if (this.living) {
          return '直播详情页'
        } else if (this.isReplay) {
          return '回放详情页'
        } else {
          return '预告详情页'
        }
      }
      // multitask() {
      //   return this.living || this.isReplay || this.taskList.length > 1
      // }
    },
    watch: {
      deblockId: {
        handler: function () {
          this.getUnlockTask()
        },
        immediate: true
      }
    },
    methods: {
      getUnlockTask() {
        getUnlockTask({
          liveId: this.deblockId || this.$route.query.id,
          type: this.living ? 2 : this.isReplay ? 3 : 1
        }).then(res => {
          if (+res.code === 0) {
            this.title = res.data.title
            this.taskList = res.data.taskList
            // this.taskList = [{"description":"加入壹心理会员，畅享精选内容>","title":"加入学习会员","type":"join_vip","event":"加入"},{"description":"进群领免费观看名额，限前500名>","title":"进群领免费直播名额","type":"join_group","event":"加入"},{"description":"邀请2名好友关注频道>","title":"邀请2名好友解锁","type":"invite","event":"去邀请"}]
          }
        })
      },
      showTaskList() {
        if (this.judgeLogin()) return
        if (this.taskList.length) {
          this.$stat.send({
            name: '直播-交互行为',
            properties: {
              行为: '点击',
              对象: this.btnText,
              页面: this.pageName,
              页面title: this.pageTitle
            }
          })
          this.qrcodeStatus = false
          this.taskListStatus = true
        }
      },
      taskClick(task = {}) {
        this.$stat.send({
          name: '直播-交互行为',
          properties: {
            行为: '点击',
            对象: '任务弹窗',
            被点击的文字: task.title,
            页面: this.pageName,
            页面title: this.pageTitle
          }
        })
        switch (task.type) {
          case 'join_group':
            this.toggleQrcode()
            break;
          case 'invite':
            this.showShareModel()
            break;
          case 'join_vip':
            this.join_vip()
            break;
        }
      },
      join_vip() {
        let sourceName = ''
        if (this.living) {
          sourceName = 'LivePlay'
        } else if (this.isReplay) {
          sourceName = 'LiveReplayDetail'
        } else {
          sourceName = 'LiveAnnouncement'
        }
        let href = `${window.$liveApi.static_url}/kc/index.html?init=25&channelId=522&sourceName=${sourceName}#/platform/vip-pay`
        window.location.href = href
      },
      closeTaskList() {
        this.taskListStatus = false
      },
      toggleQrcode() {
        this.closeTaskList()
        this.qrcodeStatus = !this.qrcodeStatus
      },
      showShareModel() {
        this.closeTaskList()
        this.shareModelStatus = true
      },
      judgeLogin() {
        if (!getToken()) {
          this.handlewxLogin()
          return true
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/mixins.scss";
  .deblocking-container {
    .replay-btn {
      padding: 16px 24px;
      border-radius: 36px;
      background-color: #fff;
      font-family: PingFangSC-Medium;
      color: #6982FA;
      font-size: 30px;
      .svg-icon {
        margin-bottom: 3px;
        fill: #6982FA;
        font-size: 18px;
      }
    }
    .task-mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      opacity: 0.4;
      background: #000000;
    }
    .task-list {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      padding: 80px 40px 30px;
      background: #FFFFFF;
      color: #21252D;
      border-radius: 30px 30px 0 0;
      &-desc {  
        font-family: PingFangSC-Medium;
        font-size: 36px;
        line-height: 36px;
        margin-bottom: 76px;
      }
      &-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 50px;
      }
    }
    .task-item-title {
      font-size: 32px;
      line-height: 48px;
    }
    .task-item-btn {
      line-height: 60px;
      width: 164px;
      color: #fff;
      text-align: center;
      background: #6982FA;
      border-radius: 40px;
    }
    .close-task {
      position: absolute;
      padding: 18px;
      top: 18px;
      right: 18px;
    }
    .qrcode {
      position: fixed;
      top: 50%;
      left: 50%;
      z-index: 2;
      transform: translate(-50%, -50%);
      background: #FFFFFF;
      border-radius: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 560px;
      padding: 60px 0 40px;
      .title {
        font-family: PingFangSC-Medium;
        font-size: 36px;
        color: #21252D;
        line-height: 36px;
      }
      .img {
        width: 320px;
        height: 320px;
        margin: 40px 0 30px;
      }
      .scan {
        font-size: 30px;
        color: #21252D;
        line-height: 36px;
      }
      .close {
        position: absolute;
        width: 48px;
        height: 48px;
        top: -24px;
        right: -24px;
      }
    }
  }
</style>
